import { BrokerConfig } from './types'
import { metricsServerApi, matchTrackerApi } from '../../modules/servers/api'
import { serverMap } from '../servers/types'

export type GetBrokersReponseBody = BrokerConfig[]

export type GetGeniusCredsResponseBody = {
  Username: string
  Password: string
  WssUrl: string
  MqttURL: string
  AmqpURL: string
}

const mqttApi = metricsServerApi.injectEndpoints({
  endpoints: (builder) => ({
    // Check Active Session
    getBrokers: builder.query<GetBrokersReponseBody, null>({
      query: () => ({
        url: `api/config/sportscasters`,
        method: 'GET'
      }),
      transformResponse: (response: GetBrokersReponseBody) => {
        return response.map((broker) => {
          if (broker.Host === '127.0.0.1') {
            return {
              ...broker,
              WSSHost: serverMap.metricsServer.defaultBroker
            }
          }
          return broker
        })
      }
    })
  })
})

const mqttCloudApi = matchTrackerApi.injectEndpoints({
  endpoints: (builder) => ({
    getGeniusCreds: builder.query<GetGeniusCredsResponseBody, void>({
      query: () => ({
        url: `mqttBroker`,
        method: 'GET'
      })
    })
  })
})

export const { useGetBrokersQuery } = mqttApi

export const { useGetGeniusCredsQuery, useLazyGetGeniusCredsQuery } =
  mqttCloudApi
